import { render, staticRenderFns } from "./ChangeCourseCampus.vue?vue&type=template&id=08908946&scoped=true&"
import script from "./ChangeCourseCampus.vue?vue&type=script&lang=ts&"
export * from "./ChangeCourseCampus.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeCourseCampus.vue?vue&type=style&index=0&id=08908946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08908946",
  null
  
)

export default component.exports